import { FC } from "react";
import { TaskAssignmentPayload } from "tm-shared/types";

import { PhotoCaptions } from "@/types/common";

import { StyledBlock, StyledTextArea } from "../../Styled";

interface TextProps {
    marketId: string;
    taskId: string;
    title: string;
    payload: TaskAssignmentPayload;
    onChangeComment: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;

    captions: PhotoCaptions;
}

export const Text: FC<TextProps> = ({ payload, onChangeComment }) => {
    return (
        <StyledBlock>
            <StyledTextArea
                placeholder="Введіть коментар"
                rows={6}
                value={payload?.comment ?? ""}
                onChange={onChangeComment}
            />
        </StyledBlock>
    );
};
